module.exports = __webpack_public_path__ + "img/profile-5.0aa38a36.png";